import React, { useState } from "react";
import { useStyles } from "./StatusSync.styles";
import clsx from "clsx";
import _ from "lodash";
import { Tab, Tabs, Grid } from "@material-ui/core";
import { faSync } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AutoSyncPage from "./AutoSync/AutoSync";
import StatusSyncPage from "./ManualSync/index";
import { useFlags } from "launchdarkly-react-client-sdk";

const StatusSync = () => {
  const classes = useStyles();
  const [selectedTabValue, setSelectedTabValue] = useState("tabStatusSync");
  const { scheduledAutoSync } = useFlags();

  const handleTabChange = (event, value) => {
    setSelectedTabValue(value);
    };

  return (
    <>
      {!scheduledAutoSync && (
        <StatusSyncPage />
      )}
      {scheduledAutoSync && (<Grid container>
        <Grid item xs={12}>
          <Tabs
            centered
            className={clsx(classes.syncTab)}
            variant="fullWidth"
            value={selectedTabValue}
            onChange={handleTabChange}
          >
            <Tab
              value="tabStatusSync"
              icon={<FontAwesomeIcon icon={faSync} size="xl" />}
              label="Status Sync"
              data-testid="statusSync-tab"
            ></Tab>
            <Tab
              value="tabAutoSync"
              icon={<FontAwesomeIcon icon={faSync} size="xl" />}
              label="Auto Sync Schedule"
              data-testid="autoSync-tab"
            ></Tab>
          </Tabs>
        </Grid>
        {selectedTabValue === "tabStatusSync" && (
          <Grid container className={classes.tabContent}>
            <Grid
              className={classes.contentContainer}
              item
              xs={12}
            >
              <StatusSyncPage />
            </Grid>
          </Grid>
        )}
        {selectedTabValue === "tabAutoSync" && (
          <Grid container className={classes.tabContent}>
            <Grid
              className={classes.contentContainer}
              item
              xs={12}
            >
              <AutoSyncPage />
            </Grid>
          </Grid>
        )}
      </Grid>
      )}
    </>
  );
};

export default StatusSync;
